import { useCurrency, formatUSD } from "../contexts/CurrencyContext";

/**
 * Displays USD value next to (or instead of) an IQD amount.
 * Modes:
 *   - both:  small "≈ $X.XX" hint (default)
 *   - iqd:   render nothing (USD hidden)
 *   - usd:   render USD prominently as the primary number
 *
 * Props:
 *   - amount: IQD amount (required)
 *   - lockedRate: optional fixed rate. When provided, uses this rate instead
 *     of the current rate - used to show historical rate on old invoices.
 */
export default function USDHint({ amount, className = "", inline = false, light = false, lockedRate = null }) {
  const { rate, showUsd, displayMode } = useCurrency();
  const effectiveRate = lockedRate && lockedRate > 0 ? lockedRate : rate;

  if (displayMode === "iqd" || !showUsd) return null;

  const num = Number(amount);
  if (!isFinite(num)) return null;

  const usdValue = formatUSD(num, effectiveRate);

  if (displayMode === "usd") {
    return (
      <span
        data-testid="usd-hint"
        data-currency-usd-primary="true"
        dir="ltr"
        className={`text-emerald-400 font-bold block ${className}`}
      >
        {usdValue.replace("≈ ", "")}
      </span>
    );
  }

  if (num === 0) return null;
  const baseColor = light ? "text-emerald-600" : "text-emerald-400/70";
  const sizeCls = inline ? "text-xs mr-2" : "text-xs mt-0.5";
  const title = lockedRate ? `سعر الصرف المحفوظ بالفاتورة: ${Number(lockedRate).toLocaleString()} د.ع/$` : undefined;

  return (
    <span
      data-testid="usd-hint"
      dir="ltr"
      title={title}
      className={`${baseColor} ${sizeCls} font-medium ${className}`}
    >
      {usdValue}
      {lockedRate ? <span className="opacity-60 mr-0.5">🔒</span> : null}
    </span>
  );
}
